export const getUserData = {
  "values": {
      "isGuest": true,
      "geo_zip": "07001",
      "conversion": {
          "large": "AW-628844503\/tu6hCLXksv0BENfP7asC",
          "short": "AW-628844503\/S8WSCK3v2NEBENfP7asC"
      }
  },
  "steps": [
      [
          "monthly_income",
          "employments_status",
          "defaulter_list"
      ],
      [
          "firstname1",
          "lastname1",
          "document_number",
          "birthday",
          "email",
          "phone",
          "accept"
      ],
      [
          "home_street",
          "home_number",
          "apartment_floor",
          "geo_city",
          "geo_province",
          "geo_zip"
      ],
      [
          "bank_account"
      ],
      [
          "gender",
          "loan_purpose",
          "marital_status",
          "company_sector",
          "education",
          "home_status",
          "regular_expenses",
          "has_debt",
          "has_car",
          "car_number",
          "online_bank"
      ]
  ],
  "inputs": {
      "monthly_income": {
          "type": "select",
          "title": {
              "text": "\u00bfCu\u00e1les son tus ingresos netos mensuales?"
          },
          "placeholder": "Seleccione una opci\u00f3n",
          "emptyErrorText": "Ingresos netos mensuales es obligatorio.",
          "notValidErrorText": "Introduce \"Ingresos\" v\u00e1lido",
          "label": "Ingresos netos mensuales",
          "options": [
              {
                  "label": "menos de 900 \u20ac",
                  "value": 900
              },
              {
                  "label": "de 900 a 1.000 \u20ac",
                  "value": 1000
              },
              {
                  "label": "de 1.000 a 1.200 \u20ac",
                  "value": 1200
              },
              {
                  "label": "de 1.200 a 1.400 \u20ac",
                  "value": 1400
              },
              {
                  "label": "m\u00e1s de 1.400 \u20ac",
                  "value": 1600
              }
          ]
      },
      "employments_status": {
          "type": "select",
          "title": {
              "text": "\u00bfCu\u00e1l es tu situaci\u00f3n laboral?"
          },
          "placeholder": "Seleccione una opci\u00f3n",
          "emptyErrorText": "Tipo de empleo es obligatorio.",
          "notValidErrorText": "Introduce un \"Tipo de empleo\" v\u00e1lido",
          "label": "Tipo de empleo",
          "options": [
              {
                  "label": "Trabajador cuenta ajena",
                  "value": 1
              },
              {
                  "label": "Aut\u00f3nomo",
                  "value": 2
              },
              {
                  "label": "Pensionista",
                  "value": 7
              },
              {
                  "label": "Funcionario",
                  "value": 3
              },
              {
                  "label": "Cobrando prestaci\u00f3n",
                  "value": 5
              },
              {
                  "label": "Desempleado",
                  "value": 4
              },
              {
                  "label": "Otro",
                  "value": 9
              }
          ]
      },
      "defaulter_list": {
          "type": "radio",
          "title": {
              "text": "\u00bfEst\u00e1s en listados de ASNEF\/RAI?"
          },
          "emptyErrorText": "Datos ASNEF\/RAI es obligatorio.",
          "notValidErrorText": "Defaulter List es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "\u00bfEst\u00e1s en listados de ASNEF\/RAI?",
          "options": [
              {
                  "label": "No",
                  "value": 0
              },
              {
                  "label": "S\u00ed",
                  "value": 1
              }
          ]
      },
      "firstname1": {
          "type": "string",
          "placeholder": "Por ejemplo: Juan",
          "description": "Nombre completo (como en DNI\/NIE)",
          "percent": 5,
          "emptyErrorText": "Nombre es obligatorio.",
          "notValidErrorText": "Introduce el nombre v\u00e1lido",
          "label": "Nombre"
      },
      "lastname1": {
          "type": "string",
          "placeholder": "Por ejemplo: Quintero Diaz",
          "description": "Como en DNI\/NIE",
          "percent": 5,
          "emptyErrorText": "Apellidos es obligatorio.",
          "notValidErrorText": "Introduce los apellidos v\u00e1lidos",
          "label": "Apellidos"
      },
      "document_number": {
          "type": "string",
          "placeholder": "Por ejemplo: X0523825F",
          "description": "Con letras",
          "percent": 15,
          "emptyErrorText": "DNI\/NIE es obligatorio.",
          "notValidErrorText": "Introduce tu DNI\/NIE v\u00e1lido",
          "label": "DNI\/NIE"
      },
      "birthday": {
          "type": "date",
          "placeholder": "__.__.____",
          "percent": 5,
          "emptyErrorText": "Introduzca una fecha v\u00e1lida.",
          "notValidErrorText": "Introduzca una fecha v\u00e1lida",
          "label": "Fecha de nacimiento"
      },
      "email": {
          "type": "string",
          "placeholder": "Por ejemplo: nombre@dominio.com",
          "percent": 5,
          "emptyErrorText": "Email es obligatorio.",
          "notValidErrorText": "Introduce un \"email\" v\u00e1lido",
          "label": "Direcci\u00f3n e-mail"
      },
      "phone": {
          "type": "string",
          "placeholder": "Por ejemplo: 603526431",
          "description": "9 digitos sin espacios ni guiones",
          "percent": 5,
          "emptyErrorText": "Tel\u00e9fono m\u00f3vil es obligatorio.",
          "notValidErrorText": "Introduce el m\u00f3vil v\u00e1lido",
          "label": "Tel\u00e9fono m\u00f3vil"
      },
      "accept": {
          "type": "checkbox",
          "emptyErrorText": "Para seguir, acepta los t\u00e9rminos y condiciones",
          "notValidErrorText": "Para seguir, acepta los t\u00e9rminos y condiciones",
          "label": "Acepto las {Condiciones} y {Politica}"
      },
      "home_street": {
          "type": "string",
          "placeholder": "Por ejemplo: Calle del Mar",
          "emptyErrorText": "Direcci\u00f3n es obligatorio.",
          "notValidErrorText": "Introduce un \"Nombre v\u00eda\" v\u00e1lido (el m\u00e1ximo es de 225 caracteres)",
          "label": "Nombre v\u00eda"
      },
      "home_number": {
          "type": "string",
          "placeholder": "Por ejemplo: 15",
          "emptyErrorText": "N\u00famero es obligatorio.",
          "notValidErrorText": "Introduce un \u201cN\u00famero\u201d v\u00e1lido (el m\u00e1ximo es de 20 caracteres)",
          "label": "N\u00famero"
      },
      "apartment_floor": {
          "type": "string",
          "placeholder": "Por ejemplo: 3A",
          "emptyErrorText": "Piso es obligatorio.",
          "notValidErrorText": "Introduce \u201cPiso y puerta\u201d v\u00e1lido (el m\u00e1ximo es de 5 caracteres)",
          "label": "Piso y puerta"
      },
      "geo_city": {
          "type": "string",
          "placeholder": "Por ejemplo: Madrid",
          "emptyErrorText": "Ciudad es obligatorio.",
          "notValidErrorText": "Geo City es muy largo (el m\u00e1ximo es de 225 caracteres)",
          "label": "Ciudad"
      },
      "geo_province": {
          "type": "select",
          "placeholder": "Provincia",
          "emptyErrorText": "Provincia es obligatorio.",
          "notValidErrorText": "Geo Province es muy largo (el m\u00e1ximo es de 225 caracteres)",
          "label": "Provincia",
          "options": [
              {
                  "label": "Araba\/\u00c1lava",
                  "value": "Araba\/\u00c1lava"
              },
              {
                  "label": "Albacete",
                  "value": "Albacete"
              },
              {
                  "label": "Alicante\/Alacant",
                  "value": "Alicante\/Alacant"
              },
              {
                  "label": "Almer\u00eda",
                  "value": "Almer\u00eda"
              },
              {
                  "label": "Asturias",
                  "value": "Asturias"
              },
              {
                  "label": "\u00c1vila",
                  "value": "\u00c1vila"
              },
              {
                  "label": "Badajoz",
                  "value": "Badajoz"
              },
              {
                  "label": "Baleares\/Illes Balears",
                  "value": "Baleares\/Illes Balears"
              },
              {
                  "label": "Barcelona",
                  "value": "Barcelona"
              },
              {
                  "label": "Bizkaia",
                  "value": "Bizkaia"
              },
              {
                  "label": "Burgos",
                  "value": "Burgos"
              },
              {
                  "label": "C\u00e1ceres",
                  "value": "C\u00e1ceres"
              },
              {
                  "label": "C\u00e1diz",
                  "value": "C\u00e1diz"
              },
              {
                  "label": "Cantabria",
                  "value": "Cantabria"
              },
              {
                  "label": "Castell\u00f3n\/Castell\u00f3",
                  "value": "Castell\u00f3n\/Castell\u00f3"
              },
              {
                  "label": "Ceuta",
                  "value": "Ceuta"
              },
              {
                  "label": "Ciudad Real",
                  "value": "Ciudad Real"
              },
              {
                  "label": "C\u00f3rdoba",
                  "value": "C\u00f3rdoba"
              },
              {
                  "label": "Coru\u00f1a, A",
                  "value": "Coru\u00f1a, A"
              },
              {
                  "label": "Cuenca",
                  "value": "Cuenca"
              },
              {
                  "label": "Girona",
                  "value": "Girona"
              },
              {
                  "label": "Gipuzkoa",
                  "value": "Gipuzkoa"
              },
              {
                  "label": "Granada",
                  "value": "Granada"
              },
              {
                  "label": "Guadalajara",
                  "value": "Guadalajara"
              },
              {
                  "label": "Huelva",
                  "value": "Huelva"
              },
              {
                  "label": "Huesca",
                  "value": "Huesca"
              },
              {
                  "label": "Islas Baleares",
                  "value": "Islas Baleares"
              },
              {
                  "label": "Ja\u00e9n",
                  "value": "Ja\u00e9n"
              },
              {
                  "label": "Le\u00f3n",
                  "value": "Le\u00f3n"
              },
              {
                  "label": "Lleida",
                  "value": "Lleida"
              },
              {
                  "label": "la manga del mar menor",
                  "value": "la manga del mar menor"
              },
              {
                  "label": "Rioja, La",
                  "value": "Rioja, La"
              },
              {
                  "label": "Lugo",
                  "value": "Lugo"
              },
              {
                  "label": "Madrid",
                  "value": "Madrid"
              },
              {
                  "label": "M\u00e1laga",
                  "value": "M\u00e1laga"
              },
              {
                  "label": "Melilla",
                  "value": "Melilla"
              },
              {
                  "label": "Murcia",
                  "value": "Murcia"
              },
              {
                  "label": "Navarra",
                  "value": "Navarra"
              },
              {
                  "label": "Ourense",
                  "value": "Ourense"
              },
              {
                  "label": "Palencia",
                  "value": "Palencia"
              },
              {
                  "label": "Palmas, Las",
                  "value": "Palmas, Las"
              },
              {
                  "label": "Pontevedra",
                  "value": "Pontevedra"
              },
              {
                  "label": "Salamanca",
                  "value": "Salamanca"
              },
              {
                  "label": "Santa Cruz de Tenerife",
                  "value": "Santa Cruz de Tenerife"
              },
              {
                  "label": "Segovia",
                  "value": "Segovia"
              },
              {
                  "label": "Sevilla",
                  "value": "Sevilla"
              },
              {
                  "label": "Soria",
                  "value": "Soria"
              },
              {
                  "label": "Tarragona",
                  "value": "Tarragona"
              },
              {
                  "label": "Teruel",
                  "value": "Teruel"
              },
              {
                  "label": "Toledo",
                  "value": "Toledo"
              },
              {
                  "label": "Valencia\/Val\u00e8ncia",
                  "value": "Valencia\/Val\u00e8ncia"
              },
              {
                  "label": "Valladolid",
                  "value": "Valladolid"
              },
              {
                  "label": "Zamora",
                  "value": "Zamora"
              },
              {
                  "label": "Zaragoza",
                  "value": "Zaragoza"
              }
          ]
      },
      "geo_zip": {
          "type": "string",
          "placeholder": "Por ejemplo: 28001",
          "emptyErrorText": "C\u00f3digo postal es obligatorio.",
          "notValidErrorText": "Introduce un \"C\u00f3digo postal\" v\u00e1lido",
          "label": "C\u00f3digo postal"
      },
      "bank_account": {
          "type": "bank",
          "title": {
              "text": "Tu solicitud est\u00e1 al 75%"
          },
          "description": "No utilizaremos este n\u00famero de cuenta sin consentimiento. Solamente es necesario para validar y proteger tu privacidad.",
          "percent": 10,
          "subtitle": "\u00bf{Name}, Cu\u00e1l es el n\u00famero de cuenta bancaria para el pr\u00e9stamo de {Value} \u20ac?",
          "emptyErrorText": "Cuenta Bancaria es obligatorio.",
          "notValidErrorText": "Introduce \u201cCuenta Bancaria\u201d v\u00e1lida (el m\u00e1ximo es de 225 caracteres)",
          "label": "Cuenta Bancaria (IBAN)"
      },
      "gender": {
          "type": "radio",
          "title": {
              "text": "G\u00e9nero"
          },
          "emptyErrorText": "G\u00e9nero es obligatorio.",
          "label": "G\u00e9nero",
          "options": [
              {
                  "label": "Mujer",
                  "value": "f"
              },
              {
                  "label": "Hombre",
                  "value": "m"
              }
          ]
      },
      "loan_purpose": {
          "type": "select",
          "title": {
              "text": "\u00bfPara qu\u00e9 utilizarias el cr\u00e9dito?"
          },
          "placeholder": "Seleccione una opci\u00f3n",
          "emptyErrorText": "Proposito del credito es obligatorio.",
          "notValidErrorText": "Loan Purpose es muy largo (el m\u00e1ximo es de 3 caracteres)",
          "label": "Proposito del credito",
          "options": [
              {
                  "label": "Ayuda",
                  "value": 1
              },
              {
                  "label": "Celebraci\u00f3n",
                  "value": 2
              },
              {
                  "label": "Coche",
                  "value": 3
              },
              {
                  "label": "Compras",
                  "value": 4
              },
              {
                  "label": "Deudas",
                  "value": 5
              },
              {
                  "label": "Reforma",
                  "value": 6
              },
              {
                  "label": "Educaci\u00f3n",
                  "value": 7
              },
              {
                  "label": "Pago de facturas",
                  "value": 8
              },
              {
                  "label": "Viajes",
                  "value": 9
              },
              {
                  "label": "Gastos Inesperados",
                  "value": 10
              },
              {
                  "label": "Medicina",
                  "value": 11
              },
              {
                  "label": "Otro",
                  "value": 12
              }
          ]
      },
      "marital_status": {
          "type": "radio",
          "title": {
              "text": "\u00bfC\u00faal es tu estado civil?"
          },
          "emptyErrorText": "Estado civil es obligatorio.",
          "notValidErrorText": "Marital Status es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "Estado civil",
          "options": [
              {
                  "label": "Soltero",
                  "value": 1
              },
              {
                  "label": "Casado",
                  "value": 2
              },
              {
                  "label": "Viudo",
                  "value": 3
              },
              {
                  "label": "Divorciado",
                  "value": 4
              }
          ]
      },
      "company_sector": {
          "type": "select",
          "title": {
              "text": "\u00bfC\u00faal es tu sector profesional?"
          },
          "placeholder": "Seleccione una opci\u00f3n",
          "emptyErrorText": "Sector profesional es obligatorio.",
          "notValidErrorText": "Company Sector es muy largo (el m\u00e1ximo es de 3 caracteres)",
          "label": "Sector profesional",
          "options": [
              {
                  "label": "Administraci\u00f3n P\u00fablica",
                  "value": 1
              },
              {
                  "label": "Agricultura\/Ganader\u00eda",
                  "value": 2
              },
              {
                  "label": "Banca\/Seguros",
                  "value": 3
              },
              {
                  "label": "Comercios",
                  "value": 4
              },
              {
                  "label": "Construcci\u00f3n",
                  "value": 5
              },
              {
                  "label": "Educaci\u00f3n",
                  "value": 6
              },
              {
                  "label": "Hosteler\u00eda",
                  "value": 7
              },
              {
                  "label": "Industria",
                  "value": 8
              },
              {
                  "label": "Militar",
                  "value": 9
              },
              {
                  "label": "Turismo",
                  "value": 10
              },
              {
                  "label": "Otro",
                  "value": 11
              }
          ]
      },
      "education": {
          "type": "radio",
          "title": {
              "text": "\u00bfQ\u00fae nivel de estudios tienes?"
          },
          "emptyErrorText": "Nivel de estudios es obligatorio.",
          "notValidErrorText": "Education es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "Nivel de estudios",
          "options": [
              {
                  "label": "Educaci\u00f3n Primaria",
                  "value": 1
              },
              {
                  "label": "Educaci\u00f3n Secundaria",
                  "value": 2
              },
              {
                  "label": "Bachillerato",
                  "value": 3
              },
              {
                  "label": "Diplomatura",
                  "value": 4
              },
              {
                  "label": "Graduado",
                  "value": 5
              }
          ]
      },
      "home_status": {
          "type": "radio",
          "title": {
              "text": "\u00bfQ\u00fae tipo de vivienda tienes?"
          },
          "emptyErrorText": "Tipo de vivienda es obligatorio.",
          "notValidErrorText": "Home Status es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "Tipo de vivienda",
          "options": [
              {
                  "label": "Alquiler",
                  "value": 1
              },
              {
                  "label": "Propiedad sin hipoteca",
                  "value": 2
              },
              {
                  "label": "Propiedad con hipoteca",
                  "value": 3
              },
              {
                  "label": "Otros",
                  "value": 4
              }
          ]
      },
      "regular_expenses": {
          "type": "select",
          "title": {
              "text": "Selecciona tus gastos medios mensuales"
          },
          "placeholder": "Seleccione una opci\u00f3n",
          "emptyErrorText": "Gastos mensuales es obligatorio.",
          "notValidErrorText": "Regular Expenses es muy largo (el m\u00e1ximo es de 4 caracteres)",
          "label": "Gastos mensuales",
          "options": [
              {
                  "label": "menos de 200 \u20ac",
                  "value": 200
              },
              {
                  "label": "de 200 a 400 \u20ac",
                  "value": 400
              },
              {
                  "label": "de 400 a 600 \u20ac",
                  "value": 600
              },
              {
                  "label": "de 600 a 800 \u20ac",
                  "value": 800
              },
              {
                  "label": "m\u00e1s de 1.000 \u20ac",
                  "value": 1000
              }
          ]
      },
      "has_debt": {
          "type": "radio",
          "title": {
              "text": "\u00bfTienes deudas de m\u00e1s de 8.000\u20ac?"
          },
          "emptyErrorText": "Para seguir contesta \u00bfTienes deudas de m\u00e1s de 8.000\u20ac?",
          "notValidErrorText": "Has Debt es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "\u00bfTienes deudas de m\u00e1s de 8.000\u20ac?",
          "options": [
              {
                  "label": "No",
                  "value": 0
              },
              {
                  "label": "S\u00ed",
                  "value": 1
              }
          ]
      },
      "has_car": {
          "type": "radio",
          "title": {
              "text": "\u00bfTienes coche con menos de 10 a\u00f1os de antig\u00fcedad?"
          },
          "emptyErrorText": "\u00bfTienes coche? - es obligatorio a contestar",
          "notValidErrorText": "Has Car es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "\u00bfTienes coche con menos de 10 a\u00f1os de antig\u00fcedad?",
          "options": [
              {
                  "label": "S\u00ed",
                  "value": 1
              },
              {
                  "label": "No",
                  "value": 0
              }
          ]
      },
      "car_number": {
          "type": "string",
          "placeholder": "Por ejemplo: 9636GJC",
          "dependencies": {
              "name": "has_car",
              "value": 1
          },
          "emptyErrorText": "Introduce un \"N\u00famero de matr\u00edcula\" v\u00e1lido",
          "notValidErrorText": "Car Number es muy largo (el m\u00e1ximo es de 25 caracteres)",
          "label": "N\u00famero de matr\u00edcula"
      },
      "online_bank": {
          "type": "radio",
          "title": {
              "text": "\u00bfTienes banca online?"
          },
          "emptyErrorText": "Para seguir contesta \u00bfTienes banca online?",
          "notValidErrorText": "Online Bank es muy largo (el m\u00e1ximo es de 1 caracteres)",
          "label": "Online Bank",
          "options": [
              {
                  "label": "S\u00ed tengo, y puedo verificarla",
                  "value": 2
              },
              {
                  "label": "S\u00ed",
                  "value": 1
              },
              {
                  "label": "No",
                  "value": 0
              }
          ]
      }
  }
}